module.exports = __webpack_public_path__ + "static/media/corporate_information_active.3082be69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/corporate_information_active.svg
// module id = 1093
// module chunks = 36